import { render, staticRenderFns } from "./MetaIcon.vue?vue&type=template&id=08d97658&scoped=true"
import script from "./MetaIcon.vue?vue&type=script&lang=js"
export * from "./MetaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d97658",
  null
  
)

export default component.exports